import { ALLOWED_FILE_TYPES } from '../../constants';

export const baseApiUrl = process.env.REACT_APP_CONSULTEE_HUB_API || '';
export const tenantId = process.env.REACT_APP_PP_TENANT_ID || '';
export const b2cClientId = process.env.REACT_APP_B2C_CLIENT_ID || '';
export const b2cScope = process.env.REACT_APP_B2C_SCOPE || '';
export const b2cAuthority = process.env.REACT_APP_B2C_AUTHORITY || '';
export const b2cPolicySignIn = process.env.REACT_APP_B2C_POLICY_SIGN_IN || '';
export const b2cPolicyImpersonate = process.env.REACT_APP_B2C_POLICY_IMPERSONATE || '';
export const mapsApiUrl = process.env.REACT_APP_WEB_MAPS_API_URL || '';
export const mapsApiKey = process.env.REACT_APP_WEB_MAPS_API_KEY || '';
export const appInsightsConnectionString =
  process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING || '';
export const allowedFileTypes = process.env.REACT_APP_ALLOWED_FILE_TYPES || ALLOWED_FILE_TYPES;
export const theme = process.env.REACT_APP_THEME || 'northern-ireland';
export const languageCode = process.env.REACT_APP_LANGCODE || 'en-gb-x-ni';
export const growthBookUrl = process.env.REACT_APP_GROWTHBOOK_URL || '';
